import api from "../instance/axios_instance.ts";
import { RecoveryPassword } from "../interface/recoveryPassword.ts";

const ForgetPasswordApi = async (data: RecoveryPassword) : Promise<CustomerInterface> => {

    try {
        const response = await api.put<RecoveryPassword>('/change_password', data, {skipAuth: true} as any);
        return response.data;
    } catch (error) {
        const mensajeError = error.response?.data?.message;
        throw new Error(mensajeError || 'Error credito');
    }
    
}

export default ForgetPasswordApi